import _taggedTemplateLiteral from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import { useToken, keyframes } from '@hub/design-system-base';
import { Box } from '@hub/box';
import { CoreContainer } from '@hub/core-container';
import { WalletMediumIcon, DeliveryMediumIcon, WestfieldDirectSwooshMediumIcon } from '@hub/icon';
import { IncludeDirectLogo } from '@hub/icon/src/with-direct-logo';
import { Link } from '@hub/link';
import { Stack } from '@hub/stack';
import { Text } from '@hub/text';
import trackEvents, { categories, labels } from '../analytics/trackEvents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const scrollToNext = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    top: 0;\n  }\n\n  25% {\n    top: 0;\n  }\n\n  30% {\n    top: -100%;\n  }\n\n  60% {\n    top: -100%;\n  }\n\n  65% {\n    top: -200%;\n  }\n\n  95% {\n    top: -200%;\n  }\n\n  100% {\n    top: -300%;\n  }\n"])));

const CVPChild = ({
  IconComponent,
  title
}) => {
  const containerHeight = useToken('sizes', 'size-xs');
  const margin = useToken('space', 'spacing-sm');
  return /*#__PURE__*/_jsx(Stack, {
    alignItems: "center",
    justify: "flex-end",
    sx: {
      position: 'relative',
      minHeight: "calc(".concat(containerHeight, " - ").concat(margin, " * 2)"),
      '&:last-child': {
        display: ['block', 'block', 'block', 'none']
      }
    },
    children: /*#__PURE__*/_jsxs(Text, {
      fontSize: "font-xs",
      color: "white",
      tone: "strong",
      sx: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        alignContent: 'center'
      },
      children: [IconComponent && /*#__PURE__*/_jsx(IconComponent, {
        sx: {
          marginRight: 'spacing-sm',
          fill: 'white'
        },
        boxSize: "size-icon-line-height-shorter"
      }), /*#__PURE__*/_jsx(IncludeDirectLogo, {
        title: title
      })]
    })
  });
};

const CVPStrip = () => /*#__PURE__*/_jsx(Link, {
  href: '/shop/info',
  onClick: () => trackEvents.clicked(categories.UNIVERSAL_HEADER, labels.BENEFITS_STRIP),
  children: /*#__PURE__*/_jsx(Box, {
    sx: {
      backgroundColor: 'blueCharcoal'
    },
    children: /*#__PURE__*/_jsx(CoreContainer, {
      sx: {
        position: 'relative',
        height: 'size-xs'
      },
      children: /*#__PURE__*/_jsxs(Stack, {
        gap: "spacing-md",
        align: ['center', 'center', 'center', 'flex-end'],
        justify: ['flex-start', 'flex-start', 'flex-start', 'center'],
        direction: ['column', 'column', 'column', 'row'],
        shouldWrapChildren: false,
        flexBasis: ['size-full', 'size-full', 'size-full', 'auto'],
        flexGrow: [1, 1, 1, 1],
        flexShrink: [0, 0, 0, 1],
        minWidth: ['size-full', 'size-full', 'size-full', 'unset'],
        sx: {
          animation: "".concat(scrollToNext, " 10s linear 1"),
          backgroundColor: 'blueCharcoal',
          padding: 'spacing-sm',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        },
        children: [/*#__PURE__*/_jsx(CVPChild, {
          title: "Westfield Plus members get more with Westfield Direct"
        }), /*#__PURE__*/_jsx(Stack, {
          alignItems: "center",
          justify: "flex-end",
          sx: {
            height: '100%',
            display: ['none', 'none', 'none', 'flex'],
            flexGrow: '0'
          },
          children: /*#__PURE__*/_jsx(WestfieldDirectSwooshMediumIcon, {
            sx: {
              marginRight: 'spacing-sm',
              marginLeft: 'spacing-sm',
              transform: 'scale(2)'
            },
            boxSize: "size-icon-line-height-shorter"
          })
        }), /*#__PURE__*/_jsx(CVPChild, {
          IconComponent: WalletMediumIcon,
          title: "Earn rewards when you Click & Collect"
        }), /*#__PURE__*/_jsx(CVPChild, {
          IconComponent: DeliveryMediumIcon,
          title: "Free delivery for orders $50 and over"
        }), /*#__PURE__*/_jsx(CVPChild, {
          title: "Westfield Plus members get more with Westfield Direct"
        })]
      })
    })
  })
});

export default CVPStrip;